import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVerticalAlignmentLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconVerticalAlignmentLeft"><Path d="M4.5 3H3V21H4.5V3Z" fill="currentColor"/><Path d="M6 6V11H21V6H6Z" fill="currentColor"/><Path d="M6 13V18H17V13H6Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVerticalAlignmentLeft;
